module.exports = __webpack_public_path__ + "img/24.9.TU.d2474bb5.png";